import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { FileTypeEnum } from 'src/app/domain/registration/enums/file-type.enum';
import { PartnerIndexMultiSelectComponent } from '../partners/crud-index/crud-index-multiselect.component';
export const RELATIVE_URL = 'downloads';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'systemName',
  'type',
  'fileType',  
  'systemVersion', 
  'createdAt', 
  'fileSize',
  'fileFormat',
  'soluctionName',
  'actions',
];

export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'soluctionName',
    display: 'TITULO',
    class: 'soluction-name-column text-center', 
    headerClass: 'soluction-name-header-column text-center', 
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.IMAGE,
    link_show: true,
    property: 'image',
    display: 'IMAGEM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'partners',
    display: 'PARCEIRO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemName',
    display: 'SOLUÇÃO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileType', 
    display: 'TIPO DE ARQUIVO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'systemVersion', 
    display: 'VERSÃO DA SOLUÇÃO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'description',
    display: 'DESCRIÇÃO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileAttachment', 
    display: 'ARQUIVO', 
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileSize',
    display: 'TAMANHO DO ARQUIVO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fileFormat',
    display: 'FORMATO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'PARCEIRO',
    component: PartnerIndexMultiSelectComponent,
    name: 'partners',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [  ],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'TITULO',
    name: 'soluctionName',
    validators: [ ],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    value:SystemTypeEnum.SYSTEM,
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SOLUÇÃO',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'system',
    display: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO DE ARQUIVO', 
    name: 'fileType',
    options: Object.values(FileTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'VERSÃO DA SOLUÇÃO', 
    name: 'systemVersion', 
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_FILE,
    label: 'ANEXAR ARQUIVO', 
    name: 'fileAttachment', 
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_TEXT_AREA,
    label: 'DESCRIÇÃO DO ARQUIVO',
    name: 'fileDescription',
    validators: [Validators.required],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];
